import React from "react"
import { FaCode, FaSketch, FaAndroid } from "react-icons/fa"

const Services = [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web development",
    text: `Build great perfomance of website is our concern.`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "web design",
    text: `We can help you design your website responsive and mobile friendly.`,
  },
  {
    id: 3,
    icon: <FaAndroid className="service-icon" />,
    title: "app design",
    text: `We are able to design your mobile application.`,
  },
]

export default Services
